module.exports = __webpack_public_path__ + "static/media/vinners.04cee7e8.png";